import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import "../styles/UniversityListPage.css";

/**
 * Slugs map to universities:
 * - trinity  → Trinity College Dublin
 * - ucd      → University College Dublin
 * - nuig     → NUIG (not supported)
 * - ucc      → UCC (not supported)
 * - dcu      → DCU (not supported)
 *
 * The actual handshake logic is handled in UniversityApplicationForm.tsx
 */

const universities = [
  {
    name: "Trinity College Dublin",
    location: "Dublin, Ireland",
    course: "Computer Science BSc",
    duration: "4 years",
    students: "18,000 students",
    slug: "trinity"
  },
  {
    name: "University College Dublin",
    location: "Dublin, Ireland",
    course: "Engineering MEng",
    duration: "5 years",
    students: "25,000 students",
    slug: "ucd"
  },
  {
    name: "National University of Ireland Galway",
    location: "Galway, Ireland",
    course: "Business Administration MBA",
    duration: "3 years",
    students: "19,000 students",
    slug: "nuig"
  },
  {
    name: "University College Cork",
    location: "Cork, Ireland",
    course: "Medicine MBBS",
    duration: "6 years",
    students: "21,000 students",
    slug: "ucc"
  },
  {
    name: "Dublin City University",
    location: "Dublin, Ireland",
    course: "Data Science MSc",
    duration: "2 years",
    students: "17,000 students",
    slug: "dcu"
  }
];

const UniversityListPage: React.FC = () => {
  return (
    <div>
      <Header />
      <div className="university-list-container">
        <Link to="/" className="back-link">← Back to Portal</Link>

        <h2>University Application Simulation</h2>
        <p>
          Select University and Course Programme<br />
          Choose from available Irish universities and courses to simulate the cross-border academic credential verification process.
        </p>

        <div className="university-list">
          {universities.map((uni) => (
            <div key={uni.slug} className="university-card">
              <div className="university-info">
                <h3>{uni.name}</h3>
                <p>{uni.location}</p>
                <p>{uni.students}</p>
              </div>

              <div className="university-details">
                <p><strong>{uni.course}</strong></p>
                <p>{uni.duration}</p>

                <Link
                  to={`/application/${uni.slug}`}
                  className="apply-btn"
                >
                  Apply to {uni.name.split(" ")[0]}
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="simulation-note">
          <h4>Simulation Process</h4>
          <p>
            Selecting a university will initiate the DOTS simulation process.
            Your academic credentials will be retrieved through the European
            Student Card system, and electronic verifications will be requested
            from your home country’s education authority.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UniversityListPage;
